export const getDateFilters = (
    date: Date,
    getStartOfHotelDayISO: (d: Date) => string,
    getEndOfHotelDayISO: (d: Date) => string
) => {
    return {
        fecha_inicial: getStartOfHotelDayISO(date),
        fecha_final: getEndOfHotelDayISO(date),
    }
}
